import { Flex } from '@radix-ui/themes';

interface ConditionContainerProps {
  children: React.ReactNode;
}

const ConditionContainer = ({ children }: ConditionContainerProps) => (
  <Flex
    direction="row"
    align="center"
    gap="4"
    justify="between"
    p="2"
    style={{
      backgroundColor: 'var(--gray-3)',
      borderRadius: '0.25rem',
      padding: '0.75rem',
      border: '1px solid var(--gray-6)',
    }}
  >
    {children}
  </Flex>
);

export default ConditionContainer;
